import api from './interceptor';

const BASE_URL_V2 = 'api/v2/rpm-package';

export default {
  // API Version 2
  getPatientPackages: patientId => api.get(`${BASE_URL_V2}/patient-packages/${patientId}`),
  getDefaultPackages: () => api.get(`${BASE_URL_V2}/default-packages`),
  assignDevice: (packageId, params) => api.put(`${BASE_URL_V2}/assign-device/${packageId}`, params),
  deletePatientPackages: patientId => api.delete(`${BASE_URL_V2}/patient-packages/${patientId}`),
  getAvailablePackages: patientId => api.get(`${BASE_URL_V2}/available-default-packages/${patientId}`),
  updatePackageParameters: (packageId, params) => api.put(`${BASE_URL_V2}/update-parameters/${packageId}`, params),
};
